import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InitiationOnStoriesEditPageQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type InitiationOnStoriesEditPageQuery = { __typename?: 'RootQueryType', initiation?: { __typename?: 'Initiation', id: string, tenantId: string, databaseId: any, sid: string, title: string, previewVideoUrl?: string | null, thumbUrl?: string | null, canUseVideoPreview?: boolean | null, updatedAt: any, firstVideo?: { __typename?: 'VideoUpload', id: string, gifWithIconUrl?: string | null } | null, owner?: { __typename?: 'User', id: string, displayName?: string | null, avatarUrl?: string | null } | null, channel?: { __typename?: 'Channel', id: string, title: string } | null, setting: { __typename?: 'InitiationSetting', id: string, locale: Types.StoryLocale, canShare: boolean, showBadge: boolean, linkPolicy: Types.ContentAccessPolicy, tenantMemberPolicy: Types.ContentAccessPolicy, isInteractive: boolean, widgetType: Types.WidgetType, widgetLive: boolean, showPages: boolean, orientation: Types.PlayerOrientationType, canChangeMediaSpeed: boolean, showChoiceLetters: boolean, choiceLetterType: Types.ChoiceLetterType }, endScreenSetting: { __typename?: 'EndScreenSetting', id: string, databaseId: any, title?: string | null, content?: string | null, textColor: string, blurEffect: number, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle: number, showCta: boolean, ctaText?: string | null, ctaUrl?: string | null, ctaBgColor?: string | null, ctaTextColor?: string | null, bgImageUpload?: { __typename?: 'ImageUpload', id: string, imageUrl?: string | null } | null, colors: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> }, widgetSetting: { __typename?: 'WidgetSetting', id: string, shape: Types.WidgetShape, size: Types.WidgetSize, allowHiding: boolean, borderColor?: string | null, bottomMargin?: number | null, caption: string, displayOnDesktop: boolean, displayOnMobile: boolean, leftAligned: boolean, showBorder: boolean, showTextBubble: boolean, sideMargin?: number | null, textBubbleBgColor?: string | null, textBubbleTextColor?: string | null, textBubbleMessage?: string | null, useVideoPreview: boolean, useFullScreen: boolean, initialPlaybackMode: Types.InitialPlaybackMode, widgetAlignment: Types.WidgetAlignment, widgetBorderRadius: number, widgetBorderThickness: number, widgetItemsPerRow: number, widgetItemWidth: number, widgetItemHeight: number, widgetItemGap: number, widgetIsResponsive: boolean }, ownerMember?: { __typename?: 'Member', id: string, displayName?: string | null, avatarUrl?: string | null } | null } | { __typename?: 'InvalidInviteToken' } | { __typename?: 'InviteRequired' } | { __typename?: 'LinkNoAccess' } | { __typename?: 'RequireInvitation' } | { __typename?: 'ShareDisabled' } | { __typename?: 'UnknownError' } | null };

export type InitiationOnStoryEditorMainNavQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type InitiationOnStoryEditorMainNavQuery = { __typename?: 'RootQueryType', initiation?: { __typename?: 'Initiation', id: string, databaseId: any, sid: string, title: string, setting: { __typename?: 'InitiationSetting', id: string, locale: Types.StoryLocale, canShare: boolean, showBadge: boolean, linkPolicy: Types.ContentAccessPolicy, tenantMemberPolicy: Types.ContentAccessPolicy, isInteractive: boolean, widgetType: Types.WidgetType, widgetLive: boolean, showPages: boolean, orientation: Types.PlayerOrientationType, canChangeMediaSpeed: boolean, showChoiceLetters: boolean, choiceLetterType: Types.ChoiceLetterType }, channel?: { __typename?: 'Channel', id: string, title: string } | null } | { __typename?: 'InvalidInviteToken' } | { __typename?: 'InviteRequired' } | { __typename?: 'LinkNoAccess' } | { __typename?: 'RequireInvitation' } | { __typename?: 'ShareDisabled' } | { __typename?: 'UnknownError' } | null };

export type InitiationOnEndScreenSettingsPageQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type InitiationOnEndScreenSettingsPageQuery = { __typename?: 'RootQueryType', initiation?: { __typename?: 'Initiation', id: string, sid: string, endScreenSetting: { __typename?: 'EndScreenSetting', id: string, databaseId: any, title?: string | null, content?: string | null, textColor: string, blurEffect: number, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle: number, showCta: boolean, ctaText?: string | null, ctaUrl?: string | null, ctaBgColor?: string | null, ctaTextColor?: string | null, bgImageUpload?: { __typename?: 'ImageUpload', id: string, imageUrl?: string | null } | null, colors: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> } } | { __typename?: 'InvalidInviteToken' } | { __typename?: 'InviteRequired' } | { __typename?: 'LinkNoAccess' } | { __typename?: 'RequireInvitation' } | { __typename?: 'ShareDisabled' } | { __typename?: 'UnknownError' } | null };

export type InitiationOnGeneralSettingsPageQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type InitiationOnGeneralSettingsPageQuery = { __typename?: 'RootQueryType', initiation?: { __typename?: 'Initiation', id: string, sid: string, setting: { __typename?: 'InitiationSetting', id: string, locale: Types.StoryLocale, canShare: boolean, showBadge: boolean, linkPolicy: Types.ContentAccessPolicy, tenantMemberPolicy: Types.ContentAccessPolicy, isInteractive: boolean, widgetType: Types.WidgetType, widgetLive: boolean, showPages: boolean, orientation: Types.PlayerOrientationType, canChangeMediaSpeed: boolean, showChoiceLetters: boolean, choiceLetterType: Types.ChoiceLetterType } } | { __typename?: 'InvalidInviteToken' } | { __typename?: 'InviteRequired' } | { __typename?: 'LinkNoAccess' } | { __typename?: 'RequireInvitation' } | { __typename?: 'ShareDisabled' } | { __typename?: 'UnknownError' } | null };

export type InitiationOnThumbSettingsPageQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type InitiationOnThumbSettingsPageQuery = { __typename?: 'RootQueryType', initiation?: { __typename?: 'Initiation', id: string, sid: string, thumbUrl?: string | null } | { __typename?: 'InvalidInviteToken' } | { __typename?: 'InviteRequired' } | { __typename?: 'LinkNoAccess' } | { __typename?: 'RequireInvitation' } | { __typename?: 'ShareDisabled' } | { __typename?: 'UnknownError' } | null };

export type InitiationSettingOnGeneralSettingsPageFragmentFragment = { __typename?: 'InitiationSetting', id: string, locale: Types.StoryLocale, canShare: boolean, showBadge: boolean, linkPolicy: Types.ContentAccessPolicy, tenantMemberPolicy: Types.ContentAccessPolicy, isInteractive: boolean, widgetType: Types.WidgetType, widgetLive: boolean, showPages: boolean, orientation: Types.PlayerOrientationType, canChangeMediaSpeed: boolean, showChoiceLetters: boolean, choiceLetterType: Types.ChoiceLetterType };

export type InitiationOnWidgetSettingsPageQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type InitiationOnWidgetSettingsPageQuery = { __typename?: 'RootQueryType', initiation?: { __typename?: 'Initiation', id: string, setting: { __typename?: 'InitiationSetting', id: string, isInteractive: boolean, widgetType: Types.WidgetType }, widgetSetting: { __typename?: 'WidgetSetting', id: string, shape: Types.WidgetShape, size: Types.WidgetSize, allowHiding: boolean, borderColor?: string | null, bottomMargin?: number | null, caption: string, displayOnDesktop: boolean, displayOnMobile: boolean, leftAligned: boolean, showBorder: boolean, showTextBubble: boolean, sideMargin?: number | null, textBubbleBgColor?: string | null, textBubbleTextColor?: string | null, textBubbleMessage?: string | null, useVideoPreview: boolean, useFullScreen: boolean, initialPlaybackMode: Types.InitialPlaybackMode, widgetAlignment: Types.WidgetAlignment, widgetBorderRadius: number, widgetBorderThickness: number, widgetItemsPerRow: number, widgetItemWidth: number, widgetItemHeight: number, widgetItemGap: number, widgetIsResponsive: boolean } } | { __typename?: 'InvalidInviteToken' } | { __typename?: 'InviteRequired' } | { __typename?: 'LinkNoAccess' } | { __typename?: 'RequireInvitation' } | { __typename?: 'ShareDisabled' } | { __typename?: 'UnknownError' } | null };

export type WidgetSettingsOnStoryEditorFragmentFragment = { __typename?: 'WidgetSetting', id: string, shape: Types.WidgetShape, size: Types.WidgetSize, allowHiding: boolean, borderColor?: string | null, bottomMargin?: number | null, caption: string, displayOnDesktop: boolean, displayOnMobile: boolean, leftAligned: boolean, showBorder: boolean, showTextBubble: boolean, sideMargin?: number | null, textBubbleBgColor?: string | null, textBubbleTextColor?: string | null, textBubbleMessage?: string | null, useVideoPreview: boolean, useFullScreen: boolean, initialPlaybackMode: Types.InitialPlaybackMode, widgetAlignment: Types.WidgetAlignment, widgetBorderRadius: number, widgetBorderThickness: number, widgetItemsPerRow: number, widgetItemWidth: number, widgetItemHeight: number, widgetItemGap: number, widgetIsResponsive: boolean };

export type InitiationOnPlayerSettingsPageQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type InitiationOnPlayerSettingsPageQuery = { __typename?: 'RootQueryType', initiation?: { __typename?: 'Initiation', id: string, setting: { __typename?: 'InitiationSetting', id: string, isInteractive: boolean, orientation: Types.PlayerOrientationType, showChoiceLetters: boolean, choiceLetterType: Types.ChoiceLetterType, canChangeMediaSpeed: boolean, showBadge: boolean }, widgetSetting: { __typename?: 'WidgetSetting', id: string, initialPlaybackMode: Types.InitialPlaybackMode } } | { __typename?: 'InvalidInviteToken' } | { __typename?: 'InviteRequired' } | { __typename?: 'LinkNoAccess' } | { __typename?: 'RequireInvitation' } | { __typename?: 'ShareDisabled' } | { __typename?: 'UnknownError' } | null };

export type SettingsForPlayerOnStoryEditorFragmentFragment = { __typename?: 'InitiationSetting', id: string, isInteractive: boolean, orientation: Types.PlayerOrientationType, showChoiceLetters: boolean, choiceLetterType: Types.ChoiceLetterType, canChangeMediaSpeed: boolean, showBadge: boolean };

export type InitiationOnStoryPlayerQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type InitiationOnStoryPlayerQuery = { __typename?: 'RootQueryType', initiation?: { __typename: 'Initiation', id: string, tenantId: string, databaseId: any, sid: string, title: string, insertedAt: any, canUseVideoPreview?: boolean | null, sessionCount?: number | null, setting: { __typename?: 'InitiationSetting', id: string, canShare: boolean, showBadge: boolean, linkPolicy: Types.ContentAccessPolicy, tenantMemberPolicy: Types.ContentAccessPolicy, locale: Types.StoryLocale, isInteractive: boolean, widgetLive: boolean, showPages: boolean, orientation: Types.PlayerOrientationType, canChangeMediaSpeed: boolean, showChoiceLetters: boolean, choiceLetterType: Types.ChoiceLetterType }, endScreenSetting: { __typename?: 'EndScreenSetting', id: string, databaseId: any, title?: string | null, content?: string | null, textColor: string, blurEffect: number, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle: number, showCta: boolean, ctaText?: string | null, ctaUrl?: string | null, ctaBgColor?: string | null, ctaTextColor?: string | null, bgImageUpload?: { __typename?: 'ImageUpload', id: string, imageUrl?: string | null } | null, colors: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> }, widgetSetting: { __typename?: 'WidgetSetting', id: string, shape: Types.WidgetShape, size: Types.WidgetSize, allowHiding: boolean, borderColor?: string | null, bottomMargin?: number | null, caption: string, displayOnDesktop: boolean, displayOnMobile: boolean, leftAligned: boolean, showBorder: boolean, showTextBubble: boolean, sideMargin?: number | null, textBubbleBgColor?: string | null, textBubbleTextColor?: string | null, textBubbleMessage?: string | null, useVideoPreview: boolean, useFullScreen: boolean, widgetAlignment: Types.WidgetAlignment, widgetBorderRadius: number, widgetBorderThickness: number, widgetItemsPerRow: number, widgetItemWidth: number, widgetItemHeight: number, widgetItemGap: number, widgetIsResponsive: boolean }, ownerMember?: { __typename?: 'Member', id: string, displayName?: string | null, avatarUrl?: string | null } | null } | { __typename: 'InvalidInviteToken' } | { __typename: 'InviteRequired', message?: string | null } | { __typename: 'LinkNoAccess', message?: string | null } | { __typename: 'RequireInvitation' } | { __typename: 'ShareDisabled' } | { __typename: 'UnknownError' } | null };

export const InitiationSettingOnGeneralSettingsPageFragmentFragmentDoc = gql`
    fragment InitiationSettingOnGeneralSettingsPageFragment on InitiationSetting {
  id
  locale
  canShare
  showBadge
  linkPolicy
  tenantMemberPolicy
  isInteractive
  widgetType
  widgetLive
  showPages
  orientation
  canChangeMediaSpeed
  showChoiceLetters
  choiceLetterType
}
    `;
export const WidgetSettingsOnStoryEditorFragmentFragmentDoc = gql`
    fragment WidgetSettingsOnStoryEditorFragment on WidgetSetting {
  id
  shape
  size
  allowHiding
  borderColor
  bottomMargin
  caption
  displayOnDesktop
  displayOnMobile
  leftAligned
  showBorder
  showTextBubble
  sideMargin
  textBubbleBgColor
  textBubbleTextColor
  textBubbleMessage
  useVideoPreview
  useFullScreen
  initialPlaybackMode
  widgetAlignment
  widgetBorderRadius
  widgetBorderThickness
  widgetItemsPerRow
  widgetItemWidth
  widgetItemHeight
  widgetItemGap
  widgetIsResponsive
}
    `;
export const SettingsForPlayerOnStoryEditorFragmentFragmentDoc = gql`
    fragment SettingsForPlayerOnStoryEditorFragment on InitiationSetting {
  id
  isInteractive
  orientation
  showChoiceLetters
  choiceLetterType
  canChangeMediaSpeed
  showBadge
}
    `;
export const InitiationOnStoriesEditPageDocument = gql`
    query initiationOnStoriesEditPage($id: String!) {
  initiation(id: $id) {
    ... on Initiation {
      id
      tenantId
      databaseId
      sid
      title
      previewVideoUrl
      thumbUrl
      canUseVideoPreview
      updatedAt
      firstVideo {
        id
        gifWithIconUrl
      }
      owner {
        id
        displayName
        avatarUrl
      }
      channel {
        id
        title
      }
      setting {
        id
        locale
        canShare
        showBadge
        linkPolicy
        tenantMemberPolicy
        isInteractive
        widgetType
        widgetLive
        showPages
        orientation
        canChangeMediaSpeed
        showChoiceLetters
        choiceLetterType
      }
      endScreenSetting {
        id
        databaseId
        title
        content
        textColor
        blurEffect
        bgType
        bgGradientType
        bgGradientAngle
        bgImageUpload {
          id
          imageUrl
        }
        colors {
          r
          g
          b
          a
          hex
        }
        showCta
        ctaText
        ctaUrl
        ctaBgColor
        ctaTextColor
      }
      widgetSetting {
        id
        shape
        size
        allowHiding
        borderColor
        bottomMargin
        caption
        displayOnDesktop
        displayOnMobile
        leftAligned
        showBorder
        showTextBubble
        sideMargin
        textBubbleBgColor
        textBubbleTextColor
        textBubbleMessage
        useVideoPreview
        useFullScreen
        initialPlaybackMode
        widgetAlignment
        widgetBorderRadius
        widgetBorderThickness
        widgetItemsPerRow
        widgetItemWidth
        widgetItemHeight
        widgetItemGap
        widgetIsResponsive
      }
      ownerMember {
        id
        displayName
        avatarUrl
      }
    }
  }
}
    `;

/**
 * __useInitiationOnStoriesEditPageQuery__
 *
 * To run a query within a React component, call `useInitiationOnStoriesEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationOnStoriesEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationOnStoriesEditPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationOnStoriesEditPageQuery(baseOptions: Apollo.QueryHookOptions<InitiationOnStoriesEditPageQuery, InitiationOnStoriesEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationOnStoriesEditPageQuery, InitiationOnStoriesEditPageQueryVariables>(InitiationOnStoriesEditPageDocument, options);
      }
export function useInitiationOnStoriesEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationOnStoriesEditPageQuery, InitiationOnStoriesEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationOnStoriesEditPageQuery, InitiationOnStoriesEditPageQueryVariables>(InitiationOnStoriesEditPageDocument, options);
        }
export type InitiationOnStoriesEditPageQueryHookResult = ReturnType<typeof useInitiationOnStoriesEditPageQuery>;
export type InitiationOnStoriesEditPageLazyQueryHookResult = ReturnType<typeof useInitiationOnStoriesEditPageLazyQuery>;
export type InitiationOnStoriesEditPageQueryResult = Apollo.QueryResult<InitiationOnStoriesEditPageQuery, InitiationOnStoriesEditPageQueryVariables>;
export function refetchInitiationOnStoriesEditPageQuery(variables: InitiationOnStoriesEditPageQueryVariables) {
      return { query: InitiationOnStoriesEditPageDocument, variables: variables }
    }
export const InitiationOnStoryEditorMainNavDocument = gql`
    query initiationOnStoryEditorMainNav($id: String!) {
  initiation(id: $id) {
    ... on Initiation {
      id
      databaseId
      sid
      title
      setting {
        id
        locale
        canShare
        showBadge
        linkPolicy
        tenantMemberPolicy
        isInteractive
        widgetType
        widgetLive
        showPages
        orientation
        canChangeMediaSpeed
        showChoiceLetters
        choiceLetterType
      }
      channel {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useInitiationOnStoryEditorMainNavQuery__
 *
 * To run a query within a React component, call `useInitiationOnStoryEditorMainNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationOnStoryEditorMainNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationOnStoryEditorMainNavQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationOnStoryEditorMainNavQuery(baseOptions: Apollo.QueryHookOptions<InitiationOnStoryEditorMainNavQuery, InitiationOnStoryEditorMainNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationOnStoryEditorMainNavQuery, InitiationOnStoryEditorMainNavQueryVariables>(InitiationOnStoryEditorMainNavDocument, options);
      }
export function useInitiationOnStoryEditorMainNavLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationOnStoryEditorMainNavQuery, InitiationOnStoryEditorMainNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationOnStoryEditorMainNavQuery, InitiationOnStoryEditorMainNavQueryVariables>(InitiationOnStoryEditorMainNavDocument, options);
        }
export type InitiationOnStoryEditorMainNavQueryHookResult = ReturnType<typeof useInitiationOnStoryEditorMainNavQuery>;
export type InitiationOnStoryEditorMainNavLazyQueryHookResult = ReturnType<typeof useInitiationOnStoryEditorMainNavLazyQuery>;
export type InitiationOnStoryEditorMainNavQueryResult = Apollo.QueryResult<InitiationOnStoryEditorMainNavQuery, InitiationOnStoryEditorMainNavQueryVariables>;
export function refetchInitiationOnStoryEditorMainNavQuery(variables: InitiationOnStoryEditorMainNavQueryVariables) {
      return { query: InitiationOnStoryEditorMainNavDocument, variables: variables }
    }
export const InitiationOnEndScreenSettingsPageDocument = gql`
    query initiationOnEndScreenSettingsPage($id: String!) {
  initiation(id: $id) {
    ... on Initiation {
      id
      sid
      endScreenSetting {
        id
        databaseId
        title
        content
        textColor
        blurEffect
        bgType
        bgGradientType
        bgGradientAngle
        bgImageUpload {
          id
          imageUrl
        }
        colors {
          r
          g
          b
          a
          hex
        }
        showCta
        ctaText
        ctaUrl
        ctaBgColor
        ctaTextColor
      }
    }
  }
}
    `;

/**
 * __useInitiationOnEndScreenSettingsPageQuery__
 *
 * To run a query within a React component, call `useInitiationOnEndScreenSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationOnEndScreenSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationOnEndScreenSettingsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationOnEndScreenSettingsPageQuery(baseOptions: Apollo.QueryHookOptions<InitiationOnEndScreenSettingsPageQuery, InitiationOnEndScreenSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationOnEndScreenSettingsPageQuery, InitiationOnEndScreenSettingsPageQueryVariables>(InitiationOnEndScreenSettingsPageDocument, options);
      }
export function useInitiationOnEndScreenSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationOnEndScreenSettingsPageQuery, InitiationOnEndScreenSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationOnEndScreenSettingsPageQuery, InitiationOnEndScreenSettingsPageQueryVariables>(InitiationOnEndScreenSettingsPageDocument, options);
        }
export type InitiationOnEndScreenSettingsPageQueryHookResult = ReturnType<typeof useInitiationOnEndScreenSettingsPageQuery>;
export type InitiationOnEndScreenSettingsPageLazyQueryHookResult = ReturnType<typeof useInitiationOnEndScreenSettingsPageLazyQuery>;
export type InitiationOnEndScreenSettingsPageQueryResult = Apollo.QueryResult<InitiationOnEndScreenSettingsPageQuery, InitiationOnEndScreenSettingsPageQueryVariables>;
export function refetchInitiationOnEndScreenSettingsPageQuery(variables: InitiationOnEndScreenSettingsPageQueryVariables) {
      return { query: InitiationOnEndScreenSettingsPageDocument, variables: variables }
    }
export const InitiationOnGeneralSettingsPageDocument = gql`
    query initiationOnGeneralSettingsPage($id: String!) {
  initiation(id: $id) {
    ... on Initiation {
      id
      sid
      setting {
        ...InitiationSettingOnGeneralSettingsPageFragment
      }
    }
  }
}
    ${InitiationSettingOnGeneralSettingsPageFragmentFragmentDoc}`;

/**
 * __useInitiationOnGeneralSettingsPageQuery__
 *
 * To run a query within a React component, call `useInitiationOnGeneralSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationOnGeneralSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationOnGeneralSettingsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationOnGeneralSettingsPageQuery(baseOptions: Apollo.QueryHookOptions<InitiationOnGeneralSettingsPageQuery, InitiationOnGeneralSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationOnGeneralSettingsPageQuery, InitiationOnGeneralSettingsPageQueryVariables>(InitiationOnGeneralSettingsPageDocument, options);
      }
export function useInitiationOnGeneralSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationOnGeneralSettingsPageQuery, InitiationOnGeneralSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationOnGeneralSettingsPageQuery, InitiationOnGeneralSettingsPageQueryVariables>(InitiationOnGeneralSettingsPageDocument, options);
        }
export type InitiationOnGeneralSettingsPageQueryHookResult = ReturnType<typeof useInitiationOnGeneralSettingsPageQuery>;
export type InitiationOnGeneralSettingsPageLazyQueryHookResult = ReturnType<typeof useInitiationOnGeneralSettingsPageLazyQuery>;
export type InitiationOnGeneralSettingsPageQueryResult = Apollo.QueryResult<InitiationOnGeneralSettingsPageQuery, InitiationOnGeneralSettingsPageQueryVariables>;
export function refetchInitiationOnGeneralSettingsPageQuery(variables: InitiationOnGeneralSettingsPageQueryVariables) {
      return { query: InitiationOnGeneralSettingsPageDocument, variables: variables }
    }
export const InitiationOnThumbSettingsPageDocument = gql`
    query initiationOnThumbSettingsPage($id: String!) {
  initiation(id: $id) {
    ... on Initiation {
      id
      sid
      thumbUrl
    }
  }
}
    `;

/**
 * __useInitiationOnThumbSettingsPageQuery__
 *
 * To run a query within a React component, call `useInitiationOnThumbSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationOnThumbSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationOnThumbSettingsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationOnThumbSettingsPageQuery(baseOptions: Apollo.QueryHookOptions<InitiationOnThumbSettingsPageQuery, InitiationOnThumbSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationOnThumbSettingsPageQuery, InitiationOnThumbSettingsPageQueryVariables>(InitiationOnThumbSettingsPageDocument, options);
      }
export function useInitiationOnThumbSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationOnThumbSettingsPageQuery, InitiationOnThumbSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationOnThumbSettingsPageQuery, InitiationOnThumbSettingsPageQueryVariables>(InitiationOnThumbSettingsPageDocument, options);
        }
export type InitiationOnThumbSettingsPageQueryHookResult = ReturnType<typeof useInitiationOnThumbSettingsPageQuery>;
export type InitiationOnThumbSettingsPageLazyQueryHookResult = ReturnType<typeof useInitiationOnThumbSettingsPageLazyQuery>;
export type InitiationOnThumbSettingsPageQueryResult = Apollo.QueryResult<InitiationOnThumbSettingsPageQuery, InitiationOnThumbSettingsPageQueryVariables>;
export function refetchInitiationOnThumbSettingsPageQuery(variables: InitiationOnThumbSettingsPageQueryVariables) {
      return { query: InitiationOnThumbSettingsPageDocument, variables: variables }
    }
export const InitiationOnWidgetSettingsPageDocument = gql`
    query initiationOnWidgetSettingsPage($id: String!) {
  initiation(id: $id) {
    ... on Initiation {
      id
      setting {
        id
        isInteractive
        widgetType
      }
      widgetSetting {
        ...WidgetSettingsOnStoryEditorFragment
      }
    }
  }
}
    ${WidgetSettingsOnStoryEditorFragmentFragmentDoc}`;

/**
 * __useInitiationOnWidgetSettingsPageQuery__
 *
 * To run a query within a React component, call `useInitiationOnWidgetSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationOnWidgetSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationOnWidgetSettingsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationOnWidgetSettingsPageQuery(baseOptions: Apollo.QueryHookOptions<InitiationOnWidgetSettingsPageQuery, InitiationOnWidgetSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationOnWidgetSettingsPageQuery, InitiationOnWidgetSettingsPageQueryVariables>(InitiationOnWidgetSettingsPageDocument, options);
      }
export function useInitiationOnWidgetSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationOnWidgetSettingsPageQuery, InitiationOnWidgetSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationOnWidgetSettingsPageQuery, InitiationOnWidgetSettingsPageQueryVariables>(InitiationOnWidgetSettingsPageDocument, options);
        }
export type InitiationOnWidgetSettingsPageQueryHookResult = ReturnType<typeof useInitiationOnWidgetSettingsPageQuery>;
export type InitiationOnWidgetSettingsPageLazyQueryHookResult = ReturnType<typeof useInitiationOnWidgetSettingsPageLazyQuery>;
export type InitiationOnWidgetSettingsPageQueryResult = Apollo.QueryResult<InitiationOnWidgetSettingsPageQuery, InitiationOnWidgetSettingsPageQueryVariables>;
export function refetchInitiationOnWidgetSettingsPageQuery(variables: InitiationOnWidgetSettingsPageQueryVariables) {
      return { query: InitiationOnWidgetSettingsPageDocument, variables: variables }
    }
export const InitiationOnPlayerSettingsPageDocument = gql`
    query initiationOnPlayerSettingsPage($id: String!) {
  initiation(id: $id) {
    ... on Initiation {
      id
      setting {
        ...SettingsForPlayerOnStoryEditorFragment
      }
      widgetSetting {
        id
        initialPlaybackMode
      }
    }
  }
}
    ${SettingsForPlayerOnStoryEditorFragmentFragmentDoc}`;

/**
 * __useInitiationOnPlayerSettingsPageQuery__
 *
 * To run a query within a React component, call `useInitiationOnPlayerSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationOnPlayerSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationOnPlayerSettingsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationOnPlayerSettingsPageQuery(baseOptions: Apollo.QueryHookOptions<InitiationOnPlayerSettingsPageQuery, InitiationOnPlayerSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationOnPlayerSettingsPageQuery, InitiationOnPlayerSettingsPageQueryVariables>(InitiationOnPlayerSettingsPageDocument, options);
      }
export function useInitiationOnPlayerSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationOnPlayerSettingsPageQuery, InitiationOnPlayerSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationOnPlayerSettingsPageQuery, InitiationOnPlayerSettingsPageQueryVariables>(InitiationOnPlayerSettingsPageDocument, options);
        }
export type InitiationOnPlayerSettingsPageQueryHookResult = ReturnType<typeof useInitiationOnPlayerSettingsPageQuery>;
export type InitiationOnPlayerSettingsPageLazyQueryHookResult = ReturnType<typeof useInitiationOnPlayerSettingsPageLazyQuery>;
export type InitiationOnPlayerSettingsPageQueryResult = Apollo.QueryResult<InitiationOnPlayerSettingsPageQuery, InitiationOnPlayerSettingsPageQueryVariables>;
export function refetchInitiationOnPlayerSettingsPageQuery(variables: InitiationOnPlayerSettingsPageQueryVariables) {
      return { query: InitiationOnPlayerSettingsPageDocument, variables: variables }
    }
export const InitiationOnStoryPlayerDocument = gql`
    query initiationOnStoryPlayer($id: String!) {
  initiation(id: $id) {
    __typename
    ... on Initiation {
      id
      tenantId
      databaseId
      sid
      title
      insertedAt
      canUseVideoPreview
      setting {
        id
        canShare
        showBadge
        linkPolicy
        tenantMemberPolicy
        locale
        isInteractive
        widgetLive
        showPages
        orientation
        canChangeMediaSpeed
        showChoiceLetters
        choiceLetterType
      }
      endScreenSetting {
        id
        databaseId
        title
        content
        textColor
        blurEffect
        bgType
        bgGradientType
        bgGradientAngle
        bgImageUpload {
          id
          imageUrl
        }
        colors {
          r
          g
          b
          a
          hex
        }
        showCta
        ctaText
        ctaUrl
        ctaBgColor
        ctaTextColor
      }
      widgetSetting {
        id
        shape
        size
        allowHiding
        borderColor
        bottomMargin
        caption
        displayOnDesktop
        displayOnMobile
        leftAligned
        showBorder
        showTextBubble
        sideMargin
        textBubbleBgColor
        textBubbleTextColor
        textBubbleMessage
        useVideoPreview
        useFullScreen
        widgetAlignment
        widgetBorderRadius
        widgetBorderThickness
        widgetItemsPerRow
        widgetItemWidth
        widgetItemHeight
        widgetItemGap
        widgetIsResponsive
      }
      ownerMember {
        id
        displayName
        avatarUrl
      }
      sessionCount
    }
    ... on LinkNoAccess {
      message
    }
    ... on InviteRequired {
      message
    }
  }
}
    `;

/**
 * __useInitiationOnStoryPlayerQuery__
 *
 * To run a query within a React component, call `useInitiationOnStoryPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationOnStoryPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationOnStoryPlayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationOnStoryPlayerQuery(baseOptions: Apollo.QueryHookOptions<InitiationOnStoryPlayerQuery, InitiationOnStoryPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationOnStoryPlayerQuery, InitiationOnStoryPlayerQueryVariables>(InitiationOnStoryPlayerDocument, options);
      }
export function useInitiationOnStoryPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationOnStoryPlayerQuery, InitiationOnStoryPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationOnStoryPlayerQuery, InitiationOnStoryPlayerQueryVariables>(InitiationOnStoryPlayerDocument, options);
        }
export type InitiationOnStoryPlayerQueryHookResult = ReturnType<typeof useInitiationOnStoryPlayerQuery>;
export type InitiationOnStoryPlayerLazyQueryHookResult = ReturnType<typeof useInitiationOnStoryPlayerLazyQuery>;
export type InitiationOnStoryPlayerQueryResult = Apollo.QueryResult<InitiationOnStoryPlayerQuery, InitiationOnStoryPlayerQueryVariables>;
export function refetchInitiationOnStoryPlayerQuery(variables: InitiationOnStoryPlayerQueryVariables) {
      return { query: InitiationOnStoryPlayerDocument, variables: variables }
    }